module.exports = __webpack_public_path__ + "static/media/approved.f92875e3.svg";